var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"integrations"},[_c('yn-list',{attrs:{"name":"integratioons","data":_vm.integrations,"total":_vm.integrations.length,"metadata":{
      source: {
        label: 'Source',
        width: '200px'
      },
      token: {
        label: 'Token',
        width: 'minmax(0, 1fr)'
      }
    },"actions":[{ name: 'delete', label: '&times;', tooltip: 'Delete this integration' }]},on:{"delete":_vm.remove}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }